export default __webpack_public_path__ + "static/media/audioHookPartner.472615e5.png";